import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import DataTable from "react-data-table-component";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import ChecklistIcon from "@mui/icons-material/Checklist";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { jwtDecode } from "jwt-decode";
import { ExportToCsv } from "export-to-csv";
import server from "../../variables";

import AddUserModal from "../../components/Addusermodel";
import GenerateBillModal from "../../components/BillGenerate";

const UserDashboard = () => {
  const notyf = new Notyf();
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [baseUsers, setBaseUsers] = useState([]);
  const [userData, setUserData] = useState({});
  const [search, setSearch] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);

  const [showUserModal, setShowUserModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [showBillModal, setShowBillModal] = useState(false);
  const [schemeID, setSchemeID] = useState(null);
  console.log('schemeID',schemeID)
  useEffect(() => {
    document.title = "Dashboard | RBS";
    fetchUsers();
  }, []);


    useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        console.log("Decoded token:", decoded);
    
        if (decoded.scheme) {
          setSchemeID(decoded.scheme);
          console.log("SchemeID from token:", decoded.schemeID);
        } else {
          console.warn("SchemeID not found in token");
        }
      } catch (error) {
        console.error("Invalid token or decode error", error);
      }
    }
  }, []);

  const fetchUsers = async () => {
    try {
      const { data } = await Axios.get(`${server}user/get-all-user`, {
        headers: { authorization: localStorage.getItem("token") },
      });

      if (data.status === 410 || data.user.role === "field") {
        navigate("/");
        return;
      }

      setUsers(data.userList);
      setBaseUsers(data.userList);
      setUserData(data.user);
    } catch {
      notyf.error("Failed to load users");
    }
  };

  /* ================= SEARCH ================= */
  const filteredUsers = useMemo(() => {
    return baseUsers.filter((u) =>
      `${u.name}${u.email}${u.userID}`
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  }, [search, baseUsers]);

  /* ================= CSV ================= */
  const exportToCSV = () => {
    const rows = selectedRows.length ? selectedRows : filteredUsers;

    const data = rows.map((u) => ({
      "User ID": u.userID,
      Name: u.name,
      Email: u.email,
      Role: u.role,
    }));

    const csvExporter = new ExportToCsv({
      filename: "User_List",
      useBom: true,
      useKeysAsHeaders: true,
    });

    csvExporter.generateCsv(data);
    notyf.success("Exporting CSV...");
  };

  /* ================= TABLE ================= */
  const columns = [
    {
      name: "User ID",
      selector: (row) => row.userID,
      sortable: true,
    },
    {
      name: "Name",
      sortable: true,
      cell: (row) =>
   
    
          row.name
   
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    // {
    //   name: "Actions",
    //   center: true,
    //   cell: (row) =>
    //     userData.role === "manager" && (
    //       <EditIcon
    //         sx={{ cursor: "pointer", color: "#f0ad4e" }}
    //         onClick={() => {
    //           setEditData(row);
    //           setShowUserModal(true);
    //         }}
    //       />
    //     ),
    // },
  ];

  return (
    <div className="page-wrapper bg-light min-vh-100">
      <div className="container p-3">

        {/* ================= TOP CARDS ================= */}
        <div className="row g-4 mb-4">
          {[
            { label: "Users" },
            { label: "Consumers", link: "/dashboard/consumers" },
          ].map((card) => (
            <div className="col-12 col-md-6" key={card.label}>
              <div
                className="card shadow-sm rounded-4 border-0 h-100"
                style={{
                  minHeight: "100px",
                  cursor: card.link ? "pointer" : "default",
                }}
                onClick={() => card.link && navigate(card.link)}
              >
                <div className="card-body d-flex justify-content-between align-items-center px-4">
                  <h4 className="mb-0 fw-semibold">{card.label}</h4>
                  <ChecklistIcon sx={{ fontSize: 42 }} className="text-primary" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ================= TABLE CARD ================= */}
        <div className="card shadow-sm rounded-4 border-0 p-4">

          {/* HEADER */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-3">
            {/* Search */}
            <div className="input-group shadow-sm search-input" >
              <span className="input-group-text bg-white border-0">
                <i className="bi bi-search text-muted"></i>
              </span>
              <input
                type="text"
                className="form-control border-0"
                placeholder="Search by name, email or ID"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            {/* Buttons */}
            <div className="d-flex gap-2">
              <button
                className="btn btn-success"
                title="Export CSV"
                onClick={exportToCSV}
              >
                <DownloadIcon fontSize="small" />
              </button>

              <button
                className="btn btn-secondary"
                title="Generate Bill"
                onClick={() => setShowBillModal(true)}
              >
                <ReceiptIcon fontSize="small" />
              </button>

              {/* {userData.role === "manager" && (
                <button
                  className="btn btn-primary"
                  title="Add User"
                  onClick={() => {
                    setEditData(null);
                    setShowUserModal(true);
                  }}
                >
                  <AddIcon fontSize="small" />
                </button>
              )} */}
            </div>
          </div>

          {/* DATATABLE */}
          <DataTable
            columns={columns}
            data={filteredUsers}
            pagination
            striped
            highlightOnHover
            selectableRows
            responsive
            onSelectedRowsChange={({ selectedRows }) =>
              setSelectedRows(selectedRows)
            }
            noDataComponent="No users found"
          />
        </div>
      </div>

      {/* ================= MODALS =================
      <AddUserModal
        show={showUserModal}
        handleClose={() => setShowUserModal(false)}
        refresh={fetchUsers}
        editData={editData}
        user={'true'}
      /> */}

      <GenerateBillModal
        show={showBillModal}
        handleClose={() => setShowBillModal(false)}
        schemeID={schemeID}
      />
    </div>
  );
};

export default UserDashboard;
